<form class="mt-5" [formGroup]="offerForm" (ngSubmit)="confirmOffer()">
  <fieldset>
    <legend class="mb-4">Please select one payment option:</legend>
    <div class="radio-options">
      @for (trait of offer().offerTraits; track trait; let i = $index) {
        <div class="radio-control">
          <input
            type="radio"
            name="offersMap"
            [id]="'payment-option-' + i"
            formControlName="offersMap"
            [value]="trait.traitId"
            />
          <label [for]="'payment-option-' + i">{{ trait.name }}</label>
        </div>
      }
    </div>
  </fieldset>

  <div class="grid-controls-wrapper mt-4">
    <div class="name-control">
      <label for="name">Name</label>
      <input type="text" id="name" formControlName="userName" appTrimSpaces />
    </div>

    <div class="role-control">
      <label for="role">Role</label>
      <input type="text" id="role" formControlName="userRole" appTrimSpaces />
    </div>

    <div class="email-control">
      <label for="email">Email</label>
      <input type="email" id="email" formControlName="email" />
    </div>

    <div class="checkbox-control auth-control">
      <input
        type="checkbox"
        name="authorizeOffer"
        id="authorization"
        formControlName="authorizeOffer"
        />
      <label for="authorization">
        By clicking Accept, I confirm that I have reviewed the offer, including
        the T&amp;Cs, and that I am authorized to accept the offer on behalf of
        the Organization.
      </label>
    </div>
  </div>

  <button class="btn-primary mt-4 submit-btn" [disabled]="!offerForm.valid">
    Accept offer
  </button>
</form>
